import React, { Fragment, useContext, useEffect } from 'react';
import CoCurriculars from './Cocurriculars';
import Slider from './Slider';
// import Cicles from '../../Helpers/Cicles';
// import CiclesMobile from '../../Helpers/Cicles/CiclesMobile';
// import Words from './Words';
import News from './News';
import Stats from './Stats';
import arrows from '../../../assets/arrow-web.png';
// import Socials from './Socials';

//Contexts
import MainContext from '../../../contexts/pages/main/mainContext';
import AboutusContext from '../../../contexts/pages/aboutus/aboutusContext'

import NewsSlider from './NewsSlider';
import IntraNews from './IntraNews';
import "./main.scss"

const MainPage = () => {

    const mainContext = useContext(MainContext);
    const { getMain } = mainContext;

    const aboutusContext = useContext(AboutusContext);
    const { getAboutus } = aboutusContext;


    useEffect(() => {
        getMain()
        getAboutus()
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Slider ClassName={'main-slider'} />
            <Stats />
            <NewsSlider ClassName={'new-slider'} />
            {/* <CoCurriculars /> */}
            {/* Se fueron 23-08-2021 */}
            {/* <Cicles /> */}
            {/* <CiclesMobile /> */}
            {/* <Words /> */}
            {/* <News /> */}
            {/* <Events /> */}
            {/* <Socials /> */}
             <section className='follow_us'>
                <h1>Síguenos</h1>
            </section>
            <div className='widget-wrapper'>
               
                <iframe id="yt-playlist" width="720" height="auto" src="https://www.youtube.com/embed/videoseries?si=WG0--m_ePHsx_cfF&amp;list=PLvsYj2HpElK8l_UJZOMK_SWyK26b8EoVg" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
<img className='arrows' src={arrows} />
<div data-behold-id="Givp2aAvhKwY0SE3ghPY">
    
                <script>
                    {
                        (() => {
                            const d = document, s = d.createElement("script"); s.type = "module";
                            s.src = "https://w.behold.so/widget.js"; d.head.append(s);
                        })()
                    }
                </script>
</div>
<img className='arrows' src={arrows}  />
                <IntraNews className="intraNews-slider"/>


            </div>
            
            {/* <NewsSlider ClassName={'new-slider'} /> */}
        </Fragment>
    );
}

export default MainPage;